/**
 * Candidate Service
 * API service for all candidate-related operations
 */

import apiClient from '../../../../apiClient';

const BASE_URL = '/ta/candidates';

export const candidateService = {
  // Get all candidates with optional filters
  async getAllCandidates(filters = {}) {
    try {
      const params = new URLSearchParams(filters);
      const response = await apiClient.get(`${BASE_URL}?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching candidates:', error);
      throw error;
    }
  },

  // Get single candidate by ID
  async getCandidateById(id) {
    try {
      const response = await apiClient.get(`${BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching candidate ${id}:`, error);
      throw error;
    }
  },

  // Create new candidate
  async createCandidate(candidateData) {
    try {
      const response = await apiClient.post(BASE_URL, candidateData);
      return response.data;
    } catch (error) {
      console.error('Error creating candidate:', error);
      throw error;
    }
  },

  // Update candidate
  async updateCandidate(id, candidateData) {
    try {
      const response = await apiClient.put(`${BASE_URL}/${id}`, candidateData);
      return response.data;
    } catch (error) {
      console.error(`Error updating candidate ${id}:`, error);
      throw error;
    }
  },

  // Delete candidate
  async deleteCandidate(id) {
    try {
      const response = await apiClient.delete(`${BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting candidate ${id}:`, error);
      throw error;
    }
  },

  // Bulk update candidates (for inline editing)
  async bulkUpdateCandidates(updates) {
    try {
      const response = await apiClient.post(`${BASE_URL}/bulk-update`, {
        updates
      });
      return response.data;
    } catch (error) {
      console.error('Error bulk updating candidates:', error);
      throw error;
    }
  }
};

export default candidateService;
